import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGaurdService implements CanActivate {
    constructor(private router: Router, private authService: AuthenticationService) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

      console.log('this.authService.isUserLoggedIn()..'+this.authService.isUserLoggedIn());
      if (this.authService.isUserLoggedIn()) {
        return true;
      } else {
      this.router.navigate(['']);
      return false;
  }
    }
  }
